import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"sticky","bottom":"0px","margin-top":"auto"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "pc-bottom-body"
}
const _hoisted_4 = {
  key: 1,
  class: "ai-icon-box"
}

import router from '@/router';
import { useMenuStore } from '@/store/menu';
import { computed, inject, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import HomeComponent from "@/components/AiComponents/HomeComponent.vue";
import CloseFabButtonComponent from '../GlobalComponents/CloseFabButtonComponent.vue';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useLocale } from '@/hooks/useLocale';

export default /*@__PURE__*/_defineComponent({
  __name: 'BottomComponent',
  setup(__props) {

const menuIndex = useMenuStore();
const IsMobile = inject<boolean>("IsMobile");
const systemConfigStore = useSystemConfigStore();

const maxHeight = computed(() => {
    return globalThis.innerHeight - 50;
});
const local = useLocale();
const aiObj = ref<{
    show: boolean;
    anchor: number;
    anchors: number[],
}>({
    show: false,
    anchor: maxHeight.value, //默认最高
    anchors: [0, maxHeight.value],
})

const activeMenuIndex = computed({
    get() {
        return menuIndex.getMenuIndex ?? 0;  // 从 store 获取值
    },
    set(value) {
        menuIndex.setMenuIndex(value);  // 通过 action 更新 store
    }
});

const route = useRoute();
const isFind = ref(false);

const menuList = computed(() => [
    {
        title: local.t('components.BottomComponent.menus.hangqing'),
        iconName: 'hangqing-',
        path: '/'
    },
    {
        title: local.t('components.BottomComponent.menus.heyue'),
        iconName: 'heyue',
        path: '/contract'
    },
    // {
    //     title: local.t('components.BottomComponent.menus.qiquan'),
    //     iconName: 'gupiaoqiquan',
    //     path: '/options'
    // },
    {
        title: local.t('components.BottomComponent.menus.xianhuo'),
        iconName: 'jiaoyi',
        path: '/transaction'
    },
    {
        title: local.t('components.BottomComponent.menus.wode'),
        iconName: 'wode',
        path: '/me'
    }
]);

watch(() => route.path, (n, o) => {
    let index = 0;
    for (let i = 0; i < menuList.value.length; i++) {
        if (menuList.value[i].path === n) {
            index = i;
            isFind.value = true;
            activeMenuIndex.value = index;
            return;
        }
    }
    isFind.value = false;
}, {
    immediate: true
});

function OnChange(index: number | string) {
    const indexNum = typeof index === 'number' ? index : +index;
    //跳转页面
    router.push(menuList.value[indexNum].path);
}

/**
 * 打开AI
 */
function OpenAi() {
    aiObj.value.show = true;
    aiObj.value.anchor = window.innerHeight * 0.6;
}

function CloseAi() {
    aiObj.value.show = false;
}

function onCloseFabButton() {

    // aiObj.value.show = false;
    aiObj.value.anchor = 0;
}


return (_ctx: any,_cache: any) => {
  const _component_var_skeleton = _resolveComponent("var-skeleton")!
  const _component_var_floating_panel = _resolveComponent("var-floating-panel")!
  const _component_var_bottom_navigation_item = _resolveComponent("var-bottom-navigation-item")!
  const _component_var_image = _resolveComponent("var-image")!
  const _component_var_bottom_navigation = _resolveComponent("var-bottom-navigation")!

  return (_unref(IsMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_var_floating_panel, {
          anchor: aiObj.value.anchor,
          "onUpdate:anchor": _cache[0] || (_cache[0] = ($event: any) => ((aiObj.value.anchor) = $event)),
          anchors: aiObj.value.anchors
        }, {
          default: _withCtx(() => [
            _createVNode(_component_var_skeleton, {
              title: "",
              avatar: "",
              card: "",
              loading: false
            }, {
              default: _withCtx(() => [
                _createVNode(HomeComponent),
                _createVNode(CloseFabButtonComponent, { onOnClose: onCloseFabButton })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["anchor", "anchors"]),
        (isFind.value)
          ? (_openBlock(), _createBlock(_component_var_bottom_navigation, {
              key: 0,
              "fab-props": { type: 'default', elevation: 24, style: 'width:50px; height:50px;border-radius: 50%;', color: 'transparent', 'iconContainer': true },
              active: activeMenuIndex.value,
              "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((activeMenuIndex).value = $event)),
              onChange: OnChange
            }, {
              fab: _withCtx(() => [
                _createVNode(_component_var_image, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (OpenAi())),
                  width: "50px",
                  height: "50px",
                  src: _ctx.$R(_unref(systemConfigStore).getConfig?.AiIconBtn)
                }, null, 8, ["src"])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (v) => {
                  return (_openBlock(), _createBlock(_component_var_bottom_navigation_item, {
                    label: v.title,
                    namespace: "icon",
                    icon: v.iconName
                  }, null, 8, ["label", "icon"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["active"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (aiObj.value.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(HomeComponent)
            ]))
          : _createCommentVNode("", true),
        (!aiObj.value.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_var_image, {
                fit: "cover",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (OpenAi())),
                width: "100%",
                height: "100%",
                src: _ctx.$R(_unref(systemConfigStore).getConfig?.AiIconBtn)
              }, null, 8, ["src"])
            ]))
          : (_openBlock(), _createBlock(CloseFabButtonComponent, {
              key: 2,
              onOnClose: CloseAi
            }))
      ]))
}
}

})